import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import App from './App.tsx'
import { installChunkReloadGuard } from './shared/chunkReload'

// Before render: recover transparently from stale-deploy chunk 404s app-wide.
installChunkReloadGuard()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
